import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 md:pt-20 md:pb-32 overflow-hidden" data-id="element-53">
      <div className="max-w-6xl mx-auto" data-id="element-54">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-55">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left z-10" data-id="element-56">
            <FadeIn data-id="element-57">
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#C75B3F]/10 text-[#C75B3F] font-medium text-sm tracking-wide mb-6" data-id="element-58">
                PARA MAMÁS INMIGRANTES
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-stone-900 leading-[1.15] mb-6 tracking-tight" data-id="element-59">
                No te falta disciplina. <br data-id="element-60" />
                <span className="text-[#C75B3F]" data-id="element-61">
                  Te falta un sistema que aguante tu vida.
                </span>
              </h1>
              <p className="text-xl text-stone-600 mb-4 max-w-lg mx-auto md:mx-0 leading-relaxed" data-id="element-62">
                Rutina anti-estrés para mamás inmigrantes que crían sin red de
                apoyo.
              </p>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="flex-1 relative w-full max-w-md md:max-w-none" data-id="element-63">
            <FadeIn delay={0.2} data-id="element-64">
              <div className="relative" data-id="element-65">
                <div className="absolute inset-0 bg-[#C75B3F]/20 rounded-[2.5rem] rotate-3 transform scale-105 blur-xl" data-id="element-66"></div>
                <img src="https://cdn.magicpatterns.com/uploads/oosW9yJ2JcGwzez1WGGYXx/3_oficial.png" alt="USA Sin Caos Guide on Phone" className="relative rounded-[2rem] shadow-2xl w-full border-4 border-white" data-id="element-67" />
              </div>
            </FadeIn>
          </div>
        </div>

        {/* CTA Button below image */}
        <FadeIn delay={0.3} data-id="element-68">
          <div className="mt-12 text-center" data-id="element-69">
            <Button onClick={scrollToPricing} className="group" data-id="element-70">
              Quiero recuperar mi calma
              <ArrowRight className="inline-block ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-71" />
            </Button>
            <p className="mt-4 text-sm text-stone-500 flex items-center justify-center gap-2" data-id="element-72">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-73"></span>
              Descarga inmediata • Solo $6.97
            </p>
          </div>
        </FadeIn>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-96 h-96 bg-[#C75B3F]/5 rounded-full blur-3xl -z-10" data-id="element-74"></div>
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-96 h-96 bg-[#C75B3F]/5 rounded-full blur-3xl -z-10" data-id="element-75"></div>
    </section>;
}